const isObj = x => x && !Array.isArray(x) && typeof x == "object";
export { isObj };